import { Loader } from 'components/Loader';
import { getStepPage } from 'constants/steps';
import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { selectAccountDetails } from 'selectors/account-selector';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchUserInformation } from 'thunks/account-thunk';

export default function DashboardOnBoarding() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { user } = useAppSelector(selectAccountDetails);

  useEffect(() => {
    if (user && user?.nextStep) {
      dispatch(fetchUserInformation());
      navigate(`/dashboard/onboarding/${getStepPage(user?.nextStep)}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user && user?.isStepCompleted) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  return (
    <div className="w-full bg-white p-20">
      {!user ? (
        <div className="mt-40 flex flex-col items-center justify-center">
          <Loader color={'#FF6606'} height={50} width={50} />
        </div>
      ) : (
        <div className="flex flex-col items-center">
          <div className="my-10 w-full">
            <Outlet />
          </div>
        </div>
      )}
    </div>
  );
}
